/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { campaignReportsAPI } from 'services/campaignReports.service';
import { axiosBaseQuery } from '../axios/index';

export const saveCampaignServiceAPI = createApi({
  reducerPath: 'SaveCampaignServiceAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api' }),
  tagTypes: [
    'Campaign/GetCampaignData',
    'Campaign/GetCampaigns',
    'Creative/LoadCreativeAndTrackingData',
    'Creative/GetCreativesList',
    // 'Campaign/GetGraphDataMergedPeriods',
    'CampaignsManage/GetCampaignChangesLog',
    'Campaign/GetCustomAudiencesForManagement',
    'Campaign/getCampaignReport',
  ],
  endpoints: (build) => ({
    UpdateCustomAudienceForManagement: build.mutation({
      query: (data) => {
        const formData = new FormData();
        for (const fieldName in data) {
          const value = data[fieldName];
          if (Array.isArray(value)) {
            formData.append(fieldName, JSON.stringify(value));
          } else {
            formData.append(fieldName, value);
          }
        }
        return {
          url: '/Campaign/UpdateCustomAudienceForManagement',
          method: 'POST',
          data: formData,
        };
      },
      invalidatesTags: ['Campaign/GetCustomAudiencesForManagement'],
    }),
    GetMinimumBid: build.query({
      query: (cm_id) => ({
        url: '/Campaign/GetMinimumBid',
        method: 'GET',
        params: { cm_id },
      }),
    }),
    GetTableCampaignData: build.query({
      query: (data) => ({ url: '/Campaign/GetCampaigns', method: 'POST', data }),
    }),
    GetSearchAppsCampaigns: build.query({
      query: () => ({
        url: '/Campaign/GetSearchAppsCampaigns',
      }),
      transformResponse: (response) => {
        return response.items;
      },
    }),
    GetCampaignDataById: build.query({
      query: (id) => {
        let objToSend;
        if (id?.env === 'direct') {
          objToSend = { ...id };
          delete objToSend.env;
        } else {
          objToSend = { id };
        }
        return {
          url: `/Campaign/LoadCampaignData`,
          method: 'GET',
          params: objToSend,
        };
      },
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Campaign/GetCampaignData'],
    }),
    GetCampaignData_newEmpty: build.query({
      query: () => ({
        url: `/Campaign/LoadCampaignData`,
      }),
      keepUnusedDataFor: 0, //not cached
      transformResponse: (response) => {
        return {
          ...response,
          //currentCampaignObj: { ...response.currentCampaignObj, isOnBoarding: '' },
        };
      },
    }),
    GetCampaignsByDate: build.query({
      query: (data) => ({
        url: `/Campaign/GetCampaigns`,
        method: 'POST',
        data: data,
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Campaign/GetCampaigns'],
      transformResponse: (response) => {
        const startTime = performance.now();
        console.log({ response });
        const { campaignsData, selectedCols, cmEvents } = response;
        const { events, eventsCohort } = createEvents(cmEvents);
        const selectedColsArray =
          selectedCols && selectedCols.trim()
            ? JSON.parse(selectedCols)
                .cols.filter((field) => field && field.colName && field.isSelected)
                .sort((a, b) => a.selectedOrder - b.selectedOrder)
                .map((field) => field.colName.toLowerCase())
            : [];
        let cpi_campaign_total_cost = 0;
        let cpi_campaign_total_installs = 0;
        const newCampaignsData = campaignsData.map((camp) => {
          camp.event_name_arr.forEach((eventName, index) => {
            const eventId = camp.event_id_arr[index];
            const eventCount = camp.eventCountArr[index];
            const eventCountCohort = camp.eventCountArrCohort[index];
            if (eventId != null && eventCount != null && eventCountCohort != null) {
              const eventFieldName = createFieldName(eventName, eventId, eventPrefix);
              const eventCohortFieldName = createFieldName(eventName, eventId, eventsCohortPrefix);
              camp[eventFieldName] = eventCount;
              camp[eventCohortFieldName] = eventCountCohort;
            }
          });
          const fixedDaily_Cost = +camp?.daily_Cost.toFixed(2);
          const fixedBudget = +camp?.budget.toFixed(2);

          const avg_cpi =
            (camp?.installs || 0) === 0 ? 0 : +((camp?.cost || 0) / (camp?.installs || 1));
          const budgetPercentage = ((fixedBudget - fixedDaily_Cost).toFixed(2) * 100) / fixedBudget;
          const ecpm = camp.eCPM ?? 0;

          if (camp?.bid_type === 3) {
            cpi_campaign_total_cost += camp?.cost;
            cpi_campaign_total_installs += camp?.installs;
          }
          return {
            ...camp,
            avg_cpi,
            ecpm,
            budgetPercentage,
            daily_Cost: fixedDaily_Cost,
            budget: fixedBudget,
          };
        });

        const endTime = performance.now();
        console.log(`Logic time : ${(endTime - startTime).toFixed(3)} ms`);
        console.log({ newCampaignsData });
        return {
          ...response,
          //campaignsData: [...newCampaignsData].slice(0, 9),
          campaignsData: newCampaignsData,
          cpi_campaign_total_cost,
          cpi_campaign_total_installs,
          selectedColsArray,
          events,
          eventsCohort,
        };
      },
    }),
    SaveCampaignData: build.mutation({
      query: (data) => ({
        url: '/Campaign/SaveCampaignData',
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        'Campaign/GetCampaigns',
        'Campaign/GetCampaignData',
        'Creative/LoadCreativeAndTrackingData',
        'Creative/GetCreativesList',
      ],
    }),
    SaveAndStartCampaign: build.mutation({
      query: (data) => ({
        url: '/Campaign/SaveCampaignData',
        method: 'POST',
        params: { activateCampaign: true },
        data,
      }),
      invalidatesTags: [
        'Campaign/GetCampaigns',
        'Campaign/GetCampaignData',
        'Creative/LoadCreativeAndTrackingData',
        'Creative/GetCreativesList',
      ],
    }),
    GetCreativesAndTrackingData: build.query({
      query: (term) => ({
        url: `/Creative/LoadCreativeAndTrackingData`,
        params: {
          ...term,
        },
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Creative/LoadCreativeAndTrackingData'],
    }),
    GetCreativesAndTrackingData_new_empty: build.query({
      query: (term) => ({
        url: `/Creative/GetCreativeAndTrackingData`,
        params: {
          ...term,
        },
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: [],
    }),
    GetLinkStateModel: build.query({
      query: (term) => ({
        url: `/Creative/GetLinkStateModel`,
        params: {
          ...term,
        },
      }),
      keepUnusedDataFor: 0,
      providesTags: [],
    }),
    GetCreativesList: build.query({
      query: ({ creativesCampaignId }) => ({
        url: `/Creative/GetCreativesList`,
        params: {
          creativesCampaignId,
        },
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: [`Creative/GetCreativesList`],
    }),
    UpdateCampaignBid: build.mutation({
      query: (data) => ({
        url: '/CampaignsManage/UpdateCampiagnBid',
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        // 'Campaign/GetGraphDataMergedPeriods',
        //'Campaign/GetCampaign',
        'Campaign/getCampaignReport',
        'CampaignsManage/GetCampaignChangesLog',
      ],
      onQueryStarted: async (arg, { queryFulfilled, dispatch }) => {
        // hard invalidate all Campaign Reports on Bid update
        // 'invalidatesTags' won't work because of the parametrs
        dispatch(
          campaignReportsAPI.util.invalidateTags([
            'Campaign/getCampaignReport',
            'Campaign/getAllExcludedApps',
          ]),
        );
      },
    }),
    UpdateDailyBudget: build.mutation({
      query: (data) => ({
        url: '/CampaignsManage/UpdateDailyBudget',
        method: 'POST',
        data,
      }),
      invalidatesTags: [
        // 'Campaign/GetGraphDataMergedPeriods',
        'CampaignsManage/GetCampaignChangesLog',
      ],
    }),
    UpdateCampaignStatus: build.mutation({
      query: (data) => ({
        url: '/CampaignsManage/UpdateCampaignStatus',
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error) => {
        // if request failed or action was cancelled → don't invalidate
        if (
          error ||
          (result &&
            result.action_cancelled &&
            (!result.s2s_tracking_enabled || !result.s2s_tracking_cpc_enabled))
        ) {
          return [];
        }
        return ['Campaign/GetCampaigns'];
      },
    }),
    UpdateWebCampaignStatus: build.mutation({
      query: (data) => ({
        url: '/CampaignsManage/UpdateWebCampaignStatus',
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error) => {
        // if request failed or action was cancelled → don't invalidate
        if (
          error ||
          (result &&
            result.action_cancelled &&
            (!result.s2s_tracking_enabled || !result.s2s_tracking_cpc_enabled))
        ) {
          return [];
        }
        return ['Campaign/GetCampaigns'];
      },
    }),
    UpdateCampaignName: build.mutation({
      query: (data) => ({
        url: '/Campaign/UpdateCampaignName',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      }),
    }),
    // GetGraphDataMergedPeriods: build.query({
    //   query: (data) => ({
    //     url: `/Campaign/GetGraphDataMergedPeriods`,
    //     method: 'POST',
    //     data,
    //   }),
    //   providesTags: ['Campaign/GetGraphDataMergedPeriods'],
    // }),
    GetCampaignChangesLog: build.query({
      query: (data) => ({
        url: `/CampaignsManage/GetCampaignChangesLog`,
        method: 'POST',
        data,
      }),
      providesTags: ['CampaignsManage/GetCampaignChangesLog'],
      transformResponse: (response) => {
        const changes = [...response];
        const groupedChanges = Object.entries(
          // What you have done
          changes.reduce(
            (
              acc,
              {
                cm_campaignid,
                event_date,
                event_type,
                previous_value,
                new_value,
                is_admin,
                user_id,
                cm_name,
                pb_name,
                user_name,
              },
            ) => {
              // Group initialization
              if (!acc[cm_campaignid]) {
                acc[cm_campaignid] = [];
              }
              // Grouping
              // FIX: only pushing the object that contains id and value
              acc[cm_campaignid].push({
                event_date,
                event_type,
                previous_value,
                new_value,
                is_admin,
                user_id,
                cm_name,
                pb_name,
                user_name,
              });
              return acc;
            },
            {},
          ),
        ).map(([cm_campaignid, changes, cm_name]) => ({ cm_campaignid, changes, cm_name }));
        return groupedChanges;
      },
    }),
    DeleteCustomAudience: build.mutation({
      query: (id) => ({
        url: `/Campaign/DeleteCustomAudience?custAudNumber=${id}`,
        method: 'POST',
        data: { id },
      }),
      invalidatesTags: ['Campaign/GetCustomAudiencesForManagement'],
    }),
    GetCustomAudiencesForManagement: build.query({
      query: () => ({
        url: '/Campaign/GetCustomAudiencesForManagement',
      }),
      providesTags: ['Campaign/GetCustomAudiencesForManagement'],
    }),
    DissconnectAssosiatedCampaigns: build.mutation({
      query: (data) => ({
        url: `/Campaign/DissconnectAudienceAssociatedCampaigns`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Campaign/GetCustomAudiencesForManagement'],
    }),
  }),
});

function createEvents(eventsList) {
  const { events, eventsCohort } = eventsList.reduce(
    (acc, event, index) => {
      acc.events.push(createEventTemplate(event, eventPrefix, index));
      acc.eventsCohort.push(createEventTemplate(event, eventsCohortPrefix, index));
      return acc;
    },
    { events: [], eventsCohort: [] },
  );
  return { events, eventsCohort };
}

function createEventTemplate(event, prefix, index) {
  return {
    cellClass: `${prefix}_content_${index}`,
    headerClass: `${prefix}_header`,
    headerName: event.eventName,
    colId: createFieldName(event.eventName, event.eventId, prefix),
    field: createFieldName(event.eventName, event.eventId, prefix),
    filter: false,
    suppressMovable: true,
    resizable: false,
    width: 110,
    minWidth: 110,
    maxWidth: 110,
    hide: !event.isSelected,
  };
}
function createFieldName(eventName, eventId, prefix) {
  const formatedName = eventName.replaceAll('.', '_!_');
  return `${prefix}_${formatedName}_${eventId}`;
}

const eventPrefix = 'events';
const eventsCohortPrefix = 'eventsCohort';
